import styles from './styles.module.scss'
import Container from '../../../elements/Container'
import Column from '../../../layout/Column'
import Columns from '../../../layout/Columns'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import LazyImage from '../../../elements/LazyImage'
import { getS3Url } from '../../../helpers/getS3Url'
import { withModifiers } from '../../../helpers/withModifiers'
import { addLinkTarget } from '../../../helpers/addLinkTarget'

const SideContent = ({ content }) => {
  const { isMobile, isSmallMobile } = useResponsive()

  return (
    <div className={styles.side}>
      <Container variant={['-xs']}>
        <Columns
          variant={[
            content.data.image_position === 'right' && 'reversed',
            '-align-middle',
            '-distribute-between'
          ]}
        >
          <Column
            variant={[isMobile && 'no-padding']}
            spans={isSmallMobile ? 12 : 5}
          >
            {(content.data.image || content.data.cloudflare_image) && (
              <div className={styles.side__image}>
                <LazyImage
                  alt={`Image ${content.title}`}
                  layout="fill"
                  sizes="(min-width: 1250px) 640px,(max-width: 640px) 100vw, 512px"
                  objectFit="cover"
                  objectPosition="50%"
                  src={getS3Url(
                    content.data.cloudflare_image || content.data.image,
                    '960'
                  )}
                />
              </div>
            )}
          </Column>

          <Column spans={isSmallMobile ? 12 : 6}>
            <div
              className={withModifiers(
                'side__description',
                [content.data.image_position === 'right' && 'reversed'],
                styles
              )}
              dangerouslySetInnerHTML={{
                __html: addLinkTarget(content.data.paragraph)
              }}
            ></div>
          </Column>
        </Columns>
      </Container>
    </div>
  )
}

export default SideContent
